var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wikiGuide",on:{"click":function($event){$event.stopPropagation();return _vm.closeWikiGuide.apply(null, arguments)}}},[_c('div',{staticClass:"con"},[_vm._v("查看百科，了解游戏")]),_c('div',{staticClass:"icon"})])}
var staticRenderFns = []

export { render, staticRenderFns }